webpackJsonp([20],{

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicle_vue__ = __webpack_require__(709);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10131019_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicle_vue__ = __webpack_require__(915);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vehicle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10131019_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vehicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(462));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    cancel: function cancel() {
      $("#deletemodal").modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#deletemodal").modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(461));

var _alphaNum = _interopRequireDefault(__webpack_require__(464));

var _numeric = _interopRequireDefault(__webpack_require__(465));

var _between = _interopRequireDefault(__webpack_require__(466));

var _email = _interopRequireDefault(__webpack_require__(467));

var _ipAddress = _interopRequireDefault(__webpack_require__(468));

var _macAddress = _interopRequireDefault(__webpack_require__(469));

var _maxLength = _interopRequireDefault(__webpack_require__(470));

var _minLength = _interopRequireDefault(__webpack_require__(471));

var _required = _interopRequireDefault(__webpack_require__(472));

var _requiredIf = _interopRequireDefault(__webpack_require__(473));

var _requiredUnless = _interopRequireDefault(__webpack_require__(474));

var _sameAs = _interopRequireDefault(__webpack_require__(475));

var _url = _interopRequireDefault(__webpack_require__(476));

var _or = _interopRequireDefault(__webpack_require__(477));

var _and = _interopRequireDefault(__webpack_require__(478));

var _not = _interopRequireDefault(__webpack_require__(479));

var _minValue = _interopRequireDefault(__webpack_require__(480));

var _maxValue = _interopRequireDefault(__webpack_require__(481));

var _integer = _interopRequireDefault(__webpack_require__(482));

var _decimal = _interopRequireDefault(__webpack_require__(483));

var helpers = _interopRequireWildcard(__webpack_require__(458));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets.s3-ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(463).withParams : __webpack_require__(230).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(458);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(485);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6066_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":"deletemodal"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                Do you want to delete this record? This process cannot be\n                undone.\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(487);




var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActiveWoSubscriber: function getAllActiveWoSubscriber() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/activewosubscriber').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getMasterOperators: function getMasterOperators(onBeginCallback, onFinallyCallback) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* asyncApi */].get(endpoint + '/list/master-operator', onBeginCallback, onFinallyCallback));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/vehicles';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllAvailable: function getAllAvailable() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/available').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getCommon: function getCommon() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/common').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/pools';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllByVehicleId: function getAllByVehicleId(vehicleId) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + vehicleId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/masterClasses';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllCommon: function getAllCommon() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/common').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAll: function getAll(filter) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  create: function create(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  update: function update(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/masterFactories';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/masterBrands';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_DeleteModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_master_vehicle_VehicleDocument__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_master_vehicle_VehiclePool__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_class_masterClassService_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_master_masterFactoryService_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_master_masterBrandService_js__ = __webpack_require__(641);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import policyService from "@/services/master/policy/policyService.js";





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_5__components_shared_DeleteModal__["a" /* default */],
    vehicleDocumentComponent: __WEBPACK_IMPORTED_MODULE_6__components_master_vehicle_VehicleDocument__["a" /* default */],
    vehiclePoolComponent: __WEBPACK_IMPORTED_MODULE_7__components_master_vehicle_VehiclePool__["a" /* default */]
  },
  computed: {
    isAllowToReadPool: function isAllowToReadPool() {
      return this.allServices && this.allServices["VehiclePool"] && this.allServices["VehiclePool"].includes("Read");
    },
    isAllowToRead: function isAllowToRead() {
      return this.allServices && this.allServices["Vehicle"] && this.allServices["Vehicle"].includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allServices && this.allServices["Vehicle"] && this.allServices["Vehicle"].includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allServices && this.allServices["Vehicle"] && this.allServices["Vehicle"].includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allServices && this.allServices["Vehicle"] && this.allServices["Vehicle"].includes("Delete");
    },
    filteredBrands: function filteredBrands() {
      var _this = this;

      return this.brands.filter(function (brand) {
        return brand.vehicleFactory.id === _this.selectedFactoryId;
      });
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: ""
      },
      isSubmitted: false,
      activeTab: "general",
      rentalLabel: null,
      airportLabel: null,
      allServices: null,
      isViewOnly: false,
      selectedFactoryId: null,
      deleteId: null,
      deleteOption: null,
      providers: [],
      defaultProviderIds: [],
      types: [],
      masterClasses: [],
      factories: [],
      brands: [],
      // transmissions: [],
      operations: [],
      allPolicies: [],
      policies: [],
      colors: [],
      items: [],
      yearsManufactured: [],
      model: {},
      imagePreview: null,
      imageData: null,
      isDefaultRentalRateAvailable: false,
      isDefaultAirportRateAvailable: false,
      isLoading: false,
      isUpdate: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        type: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        classId: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        factoryId: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        brandId: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        plateNumber: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(20) },
        modifiedProviders: { $each: { providerId: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] } } },
        feature: {
          // transmission: { required },
          color: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
          yearManufactured: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
          // doors: { required, minValue: minValue(1), maxValue: maxValue(6) },
          paxCapacity: {
            required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
            minValue: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minValue"])(1),
            maxValue: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxValue"])(100)
          }
          // largeBaggageCapacity: {
          //   required,
          //   minValue: minValue(0),
          //   maxValue: maxValue(100),
          // },
          // smallBaggageCapacity: {
          //   required,
          //   minValue: minValue(0),
          //   maxValue: maxValue(100),
          // },
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, startYear, i;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.$helper.scrollTop();
              _context.next = 3;
              return _this2.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this2.table.pageSize = _this2.$helper.extractSetting(publicSettings, "PageSize", 25);
              _this2.rentalLabel = _this2.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");
              _this2.airportLabel = _this2.$helper.extractSetting(publicSettings, "AirportLabel", "Airport");

              _context.next = 9;
              return _this2.$store.dispatch("user/getProfile");

            case 9:
              profile = _context.sent;

              _this2.allServices = profile.services;

              if (!_this2.isAllowToRead) {
                _context.next = 27;
                break;
              }

              _context.next = 14;
              return _this2.getAll();

            case 14:
              _context.next = 16;
              return _this2.getProviders();

            case 16:
              _context.next = 18;
              return _this2.getCommon();

            case 18:
              _context.next = 20;
              return _this2.getMasterClasses();

            case 20:
              _context.next = 22;
              return _this2.getMasterFactories();

            case 22:
              _context.next = 24;
              return _this2.getMasterBrands();

            case 24:
              // await this.getAllPolicies();
              startYear = new Date().getFullYear();

              for (i = 0; i < 5; i++) {
                _this2.yearsManufactured.push(startYear - i);
              }

              if (profile.selectors && profile.selectors["Providers"]) {
                _this2.defaultProviderIds = profile.selectors["Providers"].ids;
              }

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.vehiclemodal).on("hidden.bs.modal", this.closeModal);
  },
  updated: function updated() {
    // subscribe message
    this.$eventBus.$on("openVehicleDeleteModal", this.openVehicleDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("vehicle-link");
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("openVehicleDeleteModal");
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context2.next = 3;
                return _this3.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this5.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    onClickSort: function onClickSort(column) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this6.table.sort === column) {
                  _this6.table.sortDir = _this6.table.sortDir === "asc" ? "desc" : "asc";
                } else {
                  _this6.table.sortDir = "asc";
                }
                _this6.table.sort = column;
                _context6.next = 4;
                return _this6.getAll();

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    onChangeProvider: function onChangeProvider(index, item) {
      // this.getPoliciesByProviderId(index, item.providerId);
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },

    // onChangePolicy(item) {
    //   if (item.policyId === "") {
    //     item.policyId = null;
    //   }

    //   if (item.id === this.$helper.emptyGuid()) {
    //     item.state = "Created";
    //   } else {
    //     item.state = "Updated";
    //   }
    // },
    onChangeManufacturer: function onChangeManufacturer() {
      this.model.brandId = null;
      this.onChangeVehicleCommon();
    },
    onChangeVehicleCommon: function onChangeVehicleCommon() {
      this.selectedFactoryId = this.model.factoryId;
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal: function openModal(object) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, object);
      $(this.$refs.vehiclemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal: function closeModal() {
      var imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.model = {};
      $(this.$refs.vehiclemodal).modal("hide");
    },
    openVehicleDeleteModal: function openVehicleDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    onChangeImage: function onChangeImage(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      if (!["jpeg", "jpg", "png"].includes(files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase())) {
        this.imagePreview = null;
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    uploadImage: function uploadImage(id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var uploader, _$refs$cropper$getRes, canvas, model, formData, key, blob;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                uploader = document.getElementById("image-uploader");

                if (!(uploader.value && uploader.value !== "")) {
                  _context7.next = 13;
                  break;
                }

                _$refs$cropper$getRes = _this7.$refs.cropper.getResult(), canvas = _$refs$cropper$getRes.canvas;

                if (!canvas) {
                  _context7.next = 13;
                  break;
                }

                model = {
                  id: id
                };
                formData = new FormData();

                for (key in model) {
                  if (model.hasOwnProperty(key)) {
                    formData.append(key, model[key]);
                  }
                }
                _context7.next = 9;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return canvas.toBlob(resolve);
                });

              case 9:
                blob = _context7.sent;

                formData.append("file", blob, _this7.imageData.name);
                _context7.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].uploadImage(formData);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    resetImage: function resetImage() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    createItem: function createItem() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var modifiedProviders, i;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.isViewOnly = false;
                _this8.isUpdate = false;
                _this8.policies = [];
                _this8.activeTab = "general";

                modifiedProviders = [];

                if (_this8.defaultProviderIds && _this8.defaultProviderIds.length > 0) {
                  for (i = 0; i < _this8.defaultProviderIds.length; i++) {
                    modifiedProviders.push({
                      id: _this8.$helper.emptyGuid(),
                      providerId: _this8.defaultProviderIds[i],
                      // policyId: null,
                      state: "Created"
                    });
                    // this.getPoliciesByProviderId(i, modifiedProviders[i].providerId);
                  }
                } else {
                  modifiedProviders.push({
                    id: _this8.$helper.emptyGuid(),
                    providerId: null,
                    // policyId: null,
                    state: "Created"
                  });
                }

                // default parameters
                _this8.openModal({
                  classId: null,
                  factoryId: null,
                  brandId: null,
                  type: _this8.types[0].text,
                  providers: [],
                  operations: ["WithDriver", "SelfDrive"],
                  modifiedProviders: modifiedProviders,
                  feature: {
                    color: null,
                    // doors: 4,
                    hasAirConditioning: true,
                    // largeBaggageCapacity: 1,
                    // smallBaggageCapacity: 1,
                    paxCapacity: 0,
                    // transmission: this.transmissions[0].text,
                    yearManufactured: new Date().getFullYear()
                  }
                });

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    updateItem: function updateItem(item) {
      this.isViewOnly = false;
      this.isUpdate = true;
      this.selectedFactoryId = item.factoryId;
      this.imagePreview = item.imageUri;
      this.activeTab = "general";
      item.modifiedProviders = [];
      this.openModal(item);
      for (var i = 0; i < this.model.providers.length; i++) {
        this.model.modifiedProviders.push({
          id: this.model.providers[i].id,
          providerId: this.model.providers[i].providerId,
          // policyId: null,
          state: "NoAction"
        });
        // this.getPoliciesByProviderId(i, this.model.modifiedProviders[i].providerId);
        // this.model.modifiedProviders[i].policyId = this.model.providers[i].policyId;
      }
    },
    viewItem: function viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.imagePreview = item.imageUri;
      this.openModal(item);
    },
    onClickAddFactory: function onClickAddFactory() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var newFactoryName, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                newFactoryName = prompt("Please enter new manufacturer name:", "");

                if (!(newFactoryName !== null && newFactoryName !== "")) {
                  _context9.next = 13;
                  break;
                }

                _context9.prev = 2;
                _context9.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_masterFactoryService_js__["a" /* default */].create({
                  name: newFactoryName
                });

              case 5:
                _context9.next = 7;
                return _this9.getMasterFactories();

              case 7:
                _this9.$notification.success("Successfully added.", {
                  title: "Success"
                });
                _context9.next = 13;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](2);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this9.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[2, 10]]);
      }))();
    },
    onClickAddBrand: function onClickAddBrand() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var newBrandName, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                newBrandName = prompt("Please enter new model name:", "");

                if (!(newBrandName !== null && newBrandName !== "" && _this10.selectedFactoryId !== null)) {
                  _context10.next = 13;
                  break;
                }

                _context10.prev = 2;
                _context10.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_masterBrandService_js__["a" /* default */].create({
                  factoryId: _this10.selectedFactoryId,
                  name: newBrandName
                });

              case 5:
                _context10.next = 7;
                return _this10.getMasterBrands();

              case 7:
                _this10.$notification.success("Successfully added.", {
                  title: "Success"
                });
                _context10.next = 13;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](2);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[2, 10]]);
      }))();
    },
    getAll: function getAll() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (_this11.isAllowToRead) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                _context11.prev = 2;

                _this11.isLoading = true;
                filter = "?page=" + _this11.table.pageNumber + "&size=" + _this11.table.pageSize;

                if (_this11.table.keyword && _this11.table.keyword !== "") {
                  filter += "&search=" + _this11.table.keyword;
                }
                if (_this11.table.sort && _this11.table.sort !== "") {
                  filter += "&sort=" + _this11.table.sort + "&sortDir=" + _this11.table.sortDir;
                }
                _context11.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].getAll(filter);

              case 9:
                response = _context11.sent;

                _this11.items = response.data;
                _this11.table.totalPages = response.totalPages;
                _this11.table.totalRecords = response.totalRecords;
                _context11.next = 18;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](2);

                if (_context11.t0.errors) {
                  for (index = 0; index < _context11.t0.errors.length; index++) {
                    _this11.$notification.error(_context11.t0.errors[index], { title: "Error" });
                  }
                }

              case 18:
                _context11.prev = 18;

                _this11.isLoading = false;
                return _context11.finish(18);

              case 21:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[2, 15, 18, 21]]);
      }))();
    },
    getCommon: function getCommon() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var common;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].getCommon();

              case 2:
                common = _context12.sent;

                _this12.types = common.types;
                // this.transmissions = common.transmissions;
                _this12.operations = common.operations;
                _this12.colors = common.colors;

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    getProviders: function getProviders() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__["a" /* default */].getAllActive();

              case 2:
                _this13.providers = _context13.sent;

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    },
    getMasterClasses: function getMasterClasses() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_class_masterClassService_js__["a" /* default */].getAllActive();

              case 2:
                _this14.masterClasses = _context14.sent;

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this14);
      }))();
    },
    getMasterFactories: function getMasterFactories() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_masterFactoryService_js__["a" /* default */].getAll();

              case 2:
                _this15.factories = _context15.sent;

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this15);
      }))();
    },
    getMasterBrands: function getMasterBrands() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_masterBrandService_js__["a" /* default */].getAll();

              case 2:
                _this16.brands = _context16.sent;

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this16);
      }))();
    },

    // async getAllPolicies() {
    //   this.allPolicies = await policyService.getAllActive();
    // },
    // getPoliciesByProviderId(index, providerId) {
    //   if (this.model.modifiedProviders && this.model.modifiedProviders.length > 0) {
    //     this.model.modifiedProviders[index].policyId = null;
    //   }
    //   this.policies[index] = [];
    //   if (providerId && providerId !== "") {
    //     this.policies[index] = this.allPolicies.filter(
    //       (x) => x.providerId === providerId
    //     );
    //   }
    // },
    submit: function submit() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this17.isSubmitted = true;
                _this17.$v.model.$touch();

                if (!_this17.$v.model.$error) {
                  _context17.next = 4;
                  break;
                }

                return _context17.abrupt("return");

              case 4:
                _context17.prev = 4;

                _this17.isLoading = true;
                // this.model.feature.doors = parseInt(this.model.feature.doors);
                _this17.model.feature.paxCapacity = parseInt(_this17.model.feature.paxCapacity);
                // this.model.feature.smallBaggageCapacity = parseInt(
                //   this.model.feature.smallBaggageCapacity
                // );
                // this.model.feature.largeBaggageCapacity = parseInt(
                //   this.model.feature.largeBaggageCapacity
                // );
                _this17.model.feature.yearManufactured = parseInt(_this17.model.feature.yearManufactured);
                _this17.model.providers = _this17.model.modifiedProviders.map(function (x) {
                  return x;
                });

                if (!_this17.isUpdate) {
                  _context17.next = 17;
                  break;
                }

                _context17.next = 12;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].update(_this17.model);

              case 12:
                _context17.next = 14;
                return _this17.uploadImage(_this17.model.id);

              case 14:
                _this17.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context17.next = 23;
                break;

              case 17:
                _context17.next = 19;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].create(_this17.model);

              case 19:
                response = _context17.sent;
                _context17.next = 22;
                return _this17.uploadImage(response.data);

              case 22:
                _this17.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 23:
                _this17.model = {};
                _this17.closeModal();
                _context17.next = 27;
                return _this17.getAll();

              case 27:
                _context17.next = 32;
                break;

              case 29:
                _context17.prev = 29;
                _context17.t0 = _context17["catch"](4);

                if (_context17.t0.errors) {
                  for (index = 0; index < _context17.t0.errors.length; index++) {
                    _this17.$notification.error(_context17.t0.errors[index], { title: "Error" });
                  }
                }

              case 32:
                _context17.prev = 32;

                _this17.isLoading = false;
                return _context17.finish(32);

              case 35:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this17, [[4, 29, 32, 35]]);
      }))();
    },
    cancelDelete: function cancelDelete() {
      switch (this.deleteOption) {
        case "vehiclePool":
          // publish event
          this.$eventBus.$emit("openModalVehiclePool", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    deleteItem: function deleteItem() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var index, _index;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this18.isLoading = true;
                _context18.t0 = _this18.deleteOption;
                _context18.next = _context18.t0 === "vehicle" ? 5 : _context18.t0 === "vehiclePool" ? 17 : _context18.t0 === "vehicleDocument" ? 19 : 21;
                break;

              case 5:
                _context18.prev = 5;
                _context18.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].delete(_this18.deleteId);

              case 8:
                _this18.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context18.next = 11;
                return _this18.getAll();

              case 11:
                _context18.next = 16;
                break;

              case 13:
                _context18.prev = 13;
                _context18.t1 = _context18["catch"](5);

                if (_context18.t1.errors) {
                  for (index = 0; index < _context18.t1.errors.length; index++) {
                    _this18.$notification.error(_context18.t1.errors[index], {
                      title: "Error"
                    });
                  }
                }

              case 16:
                return _context18.abrupt("break", 21);

              case 17:
                // publish event
                _this18.$eventBus.$emit("deleteVehiclePool", _this18.deleteId);
                return _context18.abrupt("break", 21);

              case 19:
                // publish event
                _this18.$eventBus.$emit("deleteVehicleDocument", _this18.deleteId);
                return _context18.abrupt("break", 21);

              case 21:
                _this18.deleteId = null;
                _this18.deleteOption = null;
                $("#deletemodal").modal("hide");
                _context18.next = 29;
                break;

              case 26:
                _context18.prev = 26;
                _context18.t2 = _context18["catch"](0);

                if (_context18.t2.errors) {
                  for (_index = 0; _index < _context18.t2.errors.length; _index++) {
                    _this18.$notification.error(_context18.t2.errors[_index], { title: "Error" });
                  }
                }

              case 29:
                _context18.prev = 29;

                _this18.isLoading = false;
                return _context18.finish(29);

              case 32:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this18, [[0, 26, 29, 32], [5, 13]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this19.isLoading = true;
                _context19.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_vehicle_vehicleService_js__["a" /* default */].update(item);

              case 4:
                _this19.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context19.next = 7;
                return _this19.getAll();

              case 7:
                _context19.next = 13;
                break;

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19["catch"](0);

                item.isActive = !item.isActive;
                if (_context19.t0.errors) {
                  for (index = 0; index < _context19.t0.errors.length; index++) {
                    _this19.$notification.error(_context19.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context19.prev = 13;

                _this19.isLoading = false;
                return _context19.finish(13);

              case 16:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this19, [[0, 9, 13, 16]]);
      }))();
    },
    viewPool: function viewPool(item) {
      // publish event
      this.$eventBus.$emit("initializeVehiclePool", item);
    },
    viewDocument: function viewDocument(item) {
      // publish event
      this.$eventBus.$emit("initializeVehicleDocument", item);
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    },
    printProviders: function printProviders(item) {
      return item.length === 1 ? item[0].providerName : item.length + " providers";
    },
    printCommaBasedProviders: function printCommaBasedProviders(item) {
      return item.length > 0 ? item.map(function (x) {
        return x.providerName;
      }).join(", ") : "";
    },
    printOperations: function printOperations(item) {
      return item.length === 1 ? this.humanize(item[0]) : "All";
    },
    printCommaBasedOperations: function printCommaBasedOperations(item) {
      return item.join(", ");
    },
    addProvider: function addProvider() {
      this.model.modifiedProviders.push({
        id: this.$helper.emptyGuid(),
        providerId: null,
        // policyId: null,
        state: "Created"
      });
    },
    removeProvider: function removeProvider(index) {
      this.model.modifiedProviders[index].state = "Deleted";
    }
  }
});

/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__ = __webpack_require__(910);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedVehicle: null,
      document: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    // subscribe message
    this.$eventBus.$on("initializeVehicleDocument", this.initialize);
    this.$eventBus.$on("deleteVehicleDocument", this.deleteItem);
    this.$eventBus.$on("openModalVehicleDocument", this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeVehicleDocument");
    this.$eventBus.$off("deleteVehicleDocument");
    this.$eventBus.$off("openModalVehicleDocument");
    this.closeModal();
  },

  methods: {
    openModal: function openModal() {
      $(this.$refs.vehicledocumentmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.vehicledocumentmodal).css("overflow-y", "auto");
    },
    closeModal: function closeModal() {
      $(this.$refs.vehicledocumentmodal).modal("hide");
    },
    initialize: function initialize(vehicle) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions, uploader;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isViewOnly = !vehicle.isOwnInventory;
                _this.reset();
                _this.selectedVehicle = vehicle;

                _context.next = 7;
                return _this.$store.dispatch("user/getProfile");

              case 7:
                profile = _context.sent;
                permissions = profile.services["VehicleDocument"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.getAll();

              case 13:

                _this.openModal();
                uploader = document.getElementById("vehicle-document-uploader");

                if (uploader) {
                  uploader.value = "";
                }

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 16, 19]]);
      }))();
    },
    bindModel: function bindModel(object) {
      var uploader = document.getElementById("vehicle-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = true;
      this.document = null;
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      var uploader = document.getElementById("vehicle-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = false;
      this.document = null;
      this.resetValidations();
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].getAll(_this2.selectedVehicle.id);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onChangeDocument: function onChangeDocument(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.document = null;
        document.getElementById("vehicle-document-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      var fileExt = files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase();
      if (!["jpeg", "jpg", "png", "pdf", "xls", "xlsx", "doc", "docx"].includes(fileExt)) {
        this.document = null;
        document.getElementById("vehicle-document-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.document = files[0];
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData, key, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isSubmitted = true;
                _this3.$v.model.$touch();

                if (!_this3.$v.model.$error) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this3.isLoading = true;
                _this3.model.vehicleId = _this3.selectedVehicle.id;

                if (_this3.isUpdate) {
                  _context3.next = 16;
                  break;
                }

                formData = new FormData();

                for (key in _this3.model) {
                  if (_this3.model.hasOwnProperty(key)) {
                    formData.append(key, _this3.model[key]);
                  }
                }
                formData.append(_this3.document.name, _this3.document);
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].create(formData);

              case 13:
                _this3.$notification.success("Successfully added.", { title: "Success" });
                _context3.next = 19;
                break;

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].update(_this3.model);

              case 18:
                _this3.$notification.success("Successfully updated.", { title: "Success" });

              case 19:
                _context3.next = 21;
                return _this3.getAll();

              case 21:
                _this3.reset();
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](4);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 27:
                _context3.prev = 27;

                _this3.isLoading = false;
                return _context3.finish(27);

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 24, 27, 30]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                item.vehicleId = _this4.selectedVehicle.id;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].update(item);

              case 5:
                _this4.$notification.success("Successfully updated.", { title: "Success" });
                _this4.reset();
                _context4.next = 9;
                return _this4.getAll();

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context4.prev = 14;

                _this4.isLoading = false;
                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11, 14, 17]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.closeModal();
      // publish message
      this.$eventBus.$emit("openVehicleDeleteModal", "vehicleDocument", item.id);
    },
    deleteItem: function deleteItem(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].delete(id);

              case 4:
                _this5.$notification.success("Successfully deleted.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _this5.openModal();
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context5.prev = 14;

                _this5.isLoading = false;
                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 11, 14, 17]]);
      }))();
    },
    viewDocument: function viewDocument(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_vehicle_vehicleDocumentService_js__["a" /* default */].view(id);

              case 4:
                response = _context6.sent;

                window.open(response.data, "_blank");
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context6.prev = 11;

                _this6.isLoading = false;
                return _context6.finish(11);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8, 11, 14]]);
      }))();
    },
    printFileSize: function printFileSize(size) {
      return this.$helper.printFileSize(size);
    }
  }
});

/***/ }),

/***/ 711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_pool_poolService_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__ = __webpack_require__(913);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedVehicle: null,
      pools: [],
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        poolId: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
      }
    };
  },
  created: function created() {
    // subscribe message
    this.$eventBus.$on("initializeVehiclePool", this.initialize);
    this.$eventBus.$on("deleteVehiclePool", this.deleteItem);
    this.$eventBus.$on("openModalVehiclePool", this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeVehiclePool");
    this.$eventBus.$off("deleteVehiclePool");
    this.$eventBus.$off("openModalVehiclePool");
    this.closeModal();
  },

  methods: {
    openModal: function openModal() {
      $(this.$refs.vehiclepoolmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.vehiclepoolmodal).css("overflow-y", "auto");
    },
    closeModal: function closeModal() {
      $(this.$refs.vehiclepoolmodal).modal("hide");
    },
    initialize: function initialize(vehicle) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isViewOnly = !vehicle.isOwnInventory;
                _this.reset();
                _this.selectedVehicle = vehicle;

                _context.next = 7;
                return _this.$store.dispatch("user/getProfile");

              case 7:
                profile = _context.sent;
                permissions = profile.services["VehiclePool"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 14;
                  break;
                }

                _context.next = 13;
                return _this.getAll();

              case 13:
                _this.getPools();

              case 14:

                _this.openModal();

              case 15:
                _context.prev = 15;

                _this.isLoading = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 15, 18]]);
      }))();
    },
    bindModel: function bindModel(object) {
      this.isUpdate = true;
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      this.isUpdate = false;
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.model = {};
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__["a" /* default */].getAll(_this2.selectedVehicle.id);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPools: function getPools() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var i, pool;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_pool_poolService_js__["a" /* default */].getAllByVehicleId(_this3.selectedVehicle.id);

              case 2:
                _this3.pools = _context3.sent;


                for (i = 0; i < _this3.pools.length; i++) {
                  pool = _this3.pools[i];

                  pool.label = pool.location.name;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    submit: function submit() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isSubmitted = true;
                _this4.$v.model.$touch();

                if (!_this4.$v.model.$error) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.prev = 4;

                _this4.isLoading = true;
                _this4.model.vehicleId = _this4.selectedVehicle.id;

                if (_this4.isUpdate) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__["a" /* default */].create(_this4.model);

              case 10:
                _this4.$notification.success("Successfully added.", { title: "Success" });
                _context4.next = 16;
                break;

              case 13:
                _context4.next = 15;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__["a" /* default */].update(_this4.model);

              case 15:
                _this4.$notification.success("Successfully updated.", { title: "Success" });

              case 16:
                _this4.reset();
                _context4.next = 19;
                return _this4.getAll();

              case 19:
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](4);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 24:
                _context4.prev = 24;

                _this4.isLoading = false;
                return _context4.finish(24);

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 21, 24, 27]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__["a" /* default */].update(item);

              case 4:
                _this5.$notification.success("Successfully updated.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
                _context5.prev = 13;

                _this5.isLoading = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10, 13, 16]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.closeModal();
      this.$eventBus.$emit("openVehicleDeleteModal", "vehiclePool", item.id);
    },
    deleteItem: function deleteItem(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_master_vehicle_vehiclePoolService_js__["a" /* default */].delete(id);

              case 4:
                _this6.$notification.success("Successfully deleted.", { title: "Success" });
                _this6.reset();
                _context6.next = 8;
                return _this6.getAll();

              case 8:
                _this6.openModal();
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context6.prev = 14;

                _this6.isLoading = false;
                return _context6.finish(14);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 11, 14, 17]]);
      }))();
    }
  }
});

/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehicleDocument_vue__ = __webpack_require__(710);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e4d782_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehicleDocument_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehicleDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57e4d782_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehicleDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/vehicleDocuments';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(driverId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + driverId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  view: function view(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 911:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedVehicle)?_c('div',[_c('div',{ref:"vehicledocumentmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                Vehicle Document ("+_vm._s(_vm.selectedVehicle.factoryName)+"\n                "+_vm._s(_vm.selectedVehicle.brandName)+")\n              ")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                          This form has errors\n                        ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{
                                'field-error': _vm.isSubmitted && _vm.$v.model.name.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.name.$error)?_c('div',[(!_vm.$v.model.name.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.name.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name must be less than\n                                "+_vm._s(_vm.$v.model.name.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),(
                              !_vm.isUpdate &&
                              !_vm.isViewOnly &&
                              (_vm.isAllowToCreate || _vm.isAllowToUpdate)
                            )?_c('div',{staticClass:"mb-15"},[_c('input',{staticClass:"custom-file-input input-uploader",attrs:{"id":"vehicle-document-uploader","type":"file","accept":"image/jpeg,image/png,application/pdf,application/vnd.ms-excel","name":"document","required":""},on:{"change":function($event){return _vm.onChangeDocument($event.target.files)}}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly && (_vm.isAllowToCreate || _vm.isAllowToUpdate))?_c('div',{staticClass:"modal-footer"},[(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                              Reset\n                            ")]):_vm._e(),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Create\n                            ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Update\n                            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover table-fix mtz"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),(!_vm.isViewOnly)?_c('th',{staticClass:"text-center"},[_vm._v("Action")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                        "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                      ")])])]),_vm._v(" "),(!_vm.isViewOnly)?_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDocument(item.id)}}},[_c('span',[_vm._v("View")])])])]):_vm._e()])}),0)])])])])])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 912:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehiclePool_vue__ = __webpack_require__(711);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1080ea71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehiclePool_vue__ = __webpack_require__(914);
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehiclePool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1080ea71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehiclePool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/vehiclepools';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(vehicleId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + vehicleId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  create: function create(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  update: function update(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  delete: function _delete(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 914:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedVehicle)?_c('div',[_c('div',{ref:"vehiclepoolmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("\n                Vehicle Pool ("+_vm._s(_vm.selectedVehicle.factoryName)+"\n                "+_vm._s(_vm.selectedVehicle.brandName)+")\n              ")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                          This form has errors\n                        ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Pool")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                'field-error': _vm.isSubmitted && _vm.$v.model.poolId.$error,
                              },attrs:{"placeholder":"","label":"label","options":_vm.pools,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},model:{value:(_vm.model.poolId),callback:function ($$v) {_vm.$set(_vm.model, "poolId", $$v)},expression:"model.poolId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.poolId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Pool is required")]):_vm._e()],1),_vm._v(" "),(!_vm.isViewOnly && (_vm.isAllowToCreate || _vm.isAllowToUpdate))?_c('div',{staticClass:"modal-footer"},[(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                              Reset\n                            ")]):_vm._e(),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Create\n                            ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Update\n                            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover table-fix mtz"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Location")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),(!_vm.isViewOnly)?_c('th',{staticClass:"text-center"},[_vm._v("Action")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.location.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                        "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                      ")])])]),_vm._v(" "),(!_vm.isViewOnly)?_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e()])]):_vm._e()])}),0)])])])])])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',[_c('div',{staticClass:"table-header hidden"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"data-row --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.items.length)+" Inventory Stored")])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"table-accordion table-vehicles table-p15"},[_c('table',{staticClass:"table table-hover table-striped table-sticky"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Model")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Provider(s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    Plate No.\n                    "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('plateNumber')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Operation(s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Type & Class")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Source")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id},[_c('td',{staticStyle:{"width":"15%"}},[_c('span',[_vm._v(_vm._s(item.factoryName)+" "+_vm._s(item.brandName)+" ("+_vm._s(item.feature.color)+")")]),_vm._v(" "),_c('span',{staticClass:"year --grey50"},[_vm._v("\n                      "+_vm._s(item.feature.yearManufactured)+"\n                      ")])]),_vm._v(" "),_c('td',{staticClass:"text-center",staticStyle:{"width":"15%"},attrs:{"title":_vm.printCommaBasedProviders(item.providers)}},[_vm._v("\n                    "+_vm._s(_vm.printProviders(item.providers))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"pos-rel text-center",staticStyle:{"width":"15%"},attrs:{"title":_vm.printCommaBasedOperations(item.operations)}},[_vm._v("\n                    "+_vm._s(item.plateNumber)+"\n                    "),_c('div',{staticClass:"row-big-menu"},[_c('ul',[(!item.isOwnInventory)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewItem(item)}}},[_c('span',[_vm._v("View")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToUpdate)?_c('li',[_c('button',{staticClass:"btn btn-default --blue",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.updateItem(item)}}},[_c('span',[_vm._v("Edit")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToDelete)?_c('li',[_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openVehicleDeleteModal('vehicle', item.id)}}},[_c('span',[_vm._v("Delete")])])]):_vm._e(),_vm._v(" "),(_vm.isAllowToReadPool)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.viewPool(item)}}},[_c('span',[_vm._v("Pool")])])]):_vm._e(),_vm._v(" "),_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.viewDocument(item)}}},[_c('span',[_vm._v("Document")])])])])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm.printOperations(item.operations))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(item.type)+"\n                    "),_c('strong',{staticClass:"--blue25"},[_vm._v(_vm._s(item.className))])]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(item.source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer d-inline-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!item.isOwnInventory || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                        "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                      ")])])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"vehiclemodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Vehicle")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#vehicle-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'provider' ? 'active' : '']},[_c('a',{attrs:{"href":"#vehicle-provider","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'provider'}}},[_c('span',{staticClass:"required"},[_vm._v("Provider")])])])]),_vm._v(" "),(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"vehicle-general"}},[(_vm.imageData && !_vm.isViewOnly)?_c('div',[_c('cropper',{ref:"cropper",staticClass:"cropper-box",attrs:{"src":_vm.imagePreview}})],1):_vm._e(),_vm._v(" "),(!_vm.imageData && _vm.imagePreview)?_c('div',{staticClass:"logo-provider"},[_c('img',{attrs:{"src":_vm.imagePreview,"alt":""}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"btn-upload-wrapper"},[_c('button',{staticClass:"btn btn-upload"},[_c('i',{staticClass:"ic-up"}),_vm._v("\n                          "+_vm._s(_vm.model.imageUri
                              ? "Change picture"
                              : "Upload picture")+"\n                        ")]),_vm._v(" "),_c('input',{attrs:{"id":"image-uploader","type":"file","name":"imageData","accept":"image/jpeg,image/png"},on:{"change":function($event){return _vm.onChangeImage($event.target.files)}}}),_vm._v(" "),(_vm.imageData)?_c('button',{staticClass:"btn btn-default btn-block text-center",on:{"click":function($event){return _vm.resetImage()}}},[_vm._v("\n                          Clear\n                        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.types),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{ 'pl-20': index > 0 },on:{"click":function($event){_vm.model.type = item.text}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.type),expression:"model.type"}],staticClass:"control-radio",attrs:{"type":"radio","disabled":_vm.isViewOnly},domProps:{"value":item.text,"checked":_vm.model.type === item.text,"checked":_vm._q(_vm.model.type,item.text)},on:{"change":function($event){return _vm.$set(_vm.model, "type", item.text)}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              "+_vm._s(item.text)+"\n                            ")])])}),0),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.type.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                          Type is required\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Class")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.classId.$error,
                          },attrs:{"placeholder":"","label":"name","options":_vm.masterClasses,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},model:{value:(_vm.model.classId),callback:function ($$v) {_vm.$set(_vm.model, "classId", $$v)},expression:"model.classId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.classId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Class is required")]):_vm._e()],1),_vm._v(" "),(_vm.model.feature)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Color")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.feature.color.$error,
                          },attrs:{"placeholder":"","label":"text","options":_vm.colors,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.text; },"disabled":_vm.isViewOnly},model:{value:(_vm.model.feature.color),callback:function ($$v) {_vm.$set(_vm.model.feature, "color", $$v)},expression:"model.feature.color"}}),_vm._v(" "),(
                            _vm.isSubmitted && !_vm.$v.model.feature.color.required
                          )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Color is required")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Manufacturer")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:{
                                'col-sm-12': _vm.isViewOnly,
                                'col-sm-9': !_vm.isViewOnly,
                              }},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.factoryId.$error,
                                  },attrs:{"placeholder":"","label":"name","options":_vm.factories,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeManufacturer()}},model:{value:(_vm.model.factoryId),callback:function ($$v) {_vm.$set(_vm.model, "factoryId", $$v)},expression:"model.factoryId"}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.factoryId.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Manufacturer is required")]):_vm._e()],1)]),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.onClickAddFactory()}}},[_vm._v("\n                                  Add\n                                ")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Model")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:{
                                'col-sm-12': _vm.isViewOnly,
                                'col-sm-9': !_vm.isViewOnly,
                              }},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                    'field-error':
                                      _vm.isSubmitted && _vm.$v.model.brandId.$error,
                                  },attrs:{"placeholder":"","label":"name","options":_vm.filteredBrands,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeVehicleCommon()}},model:{value:(_vm.model.brandId),callback:function ($$v) {_vm.$set(_vm.model, "brandId", $$v)},expression:"model.brandId"}}),_vm._v(" "),(
                                    _vm.isSubmitted && !_vm.$v.model.brandId.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Model is required")]):_vm._e()],1)]),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.onClickAddBrand()}}},[_vm._v("\n                                  Add\n                                ")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Plate No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.plateNumber),expression:"model.plateNumber"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.plateNumber.$error,
                              },staticStyle:{"text-transform":"uppercase"},attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.plateNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "plateNumber", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && _vm.$v.model.plateNumber.$error
                              )?_c('div',[(!_vm.$v.model.plateNumber.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Plate Number is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.plateNumber.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Plate Number must be less than\n                                "+_vm._s(_vm.$v.model.plateNumber.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.model.feature)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Year Manufactured")]),_vm._v(" "),(!_vm.isUpdate)?_c('div',[_c('v-select',{staticClass:"v-search-select",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.feature.yearManufactured.$error,
                                },attrs:{"placeholder":"","options":_vm.yearsManufactured,"clearable":true,"searchable":true,"filterable":true,"disabled":_vm.isViewOnly},model:{value:(_vm.model.feature.yearManufactured),callback:function ($$v) {_vm.$set(_vm.model.feature, "yearManufactured", $$v)},expression:"model.feature.yearManufactured"}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  !_vm.$v.model.feature.yearManufactured.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Year is required")]):_vm._e()],1):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.feature.yearManufactured),expression:"model.feature.yearManufactured"}],staticClass:"form-control",attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.model.feature.yearManufactured)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.feature, "yearManufactured", $event.target.value)}}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[(_vm.model.feature)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Pax Capacity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.feature.paxCapacity),expression:"model.feature.paxCapacity"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.feature.paxCapacity.$error,
                              },attrs:{"type":"number","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.feature.paxCapacity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.feature, "paxCapacity", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-filter"},[_vm._v("Less Driver")]),_vm._v(" "),(
                                _vm.isSubmitted &&
                                _vm.$v.model.feature.paxCapacity.$error
                              )?_c('div',[(!_vm.$v.model.feature.paxCapacity.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Pax Capacity is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.feature.paxCapacity.minValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Min Pax Capacity is\n                                "+_vm._s(_vm.$v.model.feature.paxCapacity.$params
                                    .minValue.min))]):_vm._e(),_vm._v(" "),(!_vm.$v.model.feature.paxCapacity.maxValue)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Max Pax Capacity is\n                                "+_vm._s(_vm.$v.model.feature.paxCapacity.$params
                                    .maxValue.max))]):_vm._e()]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.model.feature)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.feature.hasAirConditioning),expression:"model.feature.hasAirConditioning"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly},domProps:{"checked":Array.isArray(_vm.model.feature.hasAirConditioning)?_vm._i(_vm.model.feature.hasAirConditioning,null)>-1:(_vm.model.feature.hasAirConditioning)},on:{"change":function($event){var $$a=_vm.model.feature.hasAirConditioning,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.feature, "hasAirConditioning", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.feature, "hasAirConditioning", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.feature, "hasAirConditioning", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                            Air Conditioning\n                          ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Operation")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.operations),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{ 'pl-20': index > 0 }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.operations),expression:"model.operations"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly},domProps:{"value":item.text,"checked":Array.isArray(_vm.model.operations)?_vm._i(_vm.model.operations,item.text)>-1:(_vm.model.operations)},on:{"change":function($event){var $$a=_vm.model.operations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.text,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "operations", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "operations", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "operations", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                              "+_vm._s(_vm.humanize(item.text))+"\n                            ")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'provider' ? 'in active' : ''],attrs:{"id":"vehicle-provider"}},[_vm._l((_vm.model.modifiedProviders),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Provider")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedProviders.$each[index]
                                      .providerId.$error,
                                },attrs:{"placeholder":"","label":"name","options":_vm.providers,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},on:{"input":function($event){return _vm.onChangeProvider(index, item)}},model:{value:(item.providerId),callback:function ($$v) {_vm.$set(item, "providerId", $$v)},expression:"item.providerId"}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  !_vm.$v.model.modifiedProviders.$each[index]
                                    .providerId.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Provider is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                  _vm.model.modifiedProviders &&
                                  _vm.model.modifiedProviders.length > 1 &&
                                  index > 0
                                )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeProvider(index)}}},[_vm._v("\n                                Remove\n                              ")]):_vm._e()])])]):_vm._e()])}),_vm._v(" "),(_vm.providers && _vm.model.modifiedProviders)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model.modifiedProviders)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addProvider()}}},[_vm._v("\n                            Add\n                          ")]):_vm._e()])]):_vm._e()],2)]),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])]):_vm._e()])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.deleteItem,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('vehicleDocumentComponent'),_vm._v(" "),_c('vehiclePoolComponent'),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Fleet Master")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Vehicles\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Vehicles\n                  "),_c('span',[_c('i',{staticClass:"ic-car"})])]),_vm._v(" "),_c('p',[_vm._v("\n                  Manage your vehicle data, including details of brand, type,\n                  rate and services to support your business demand.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 text-right"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group mb-15",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default btn-active",attrs:{"type":"button"}},[_vm._v("\n                      All Type\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Car")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Bus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("\n                      Motorcycle\n                    ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.50af0e45111c364d8408.js